import { getEmployees } from "../../../api/employees";

export const INSURANCE_FIELDS = [
  {
    key: "employee_id",
    label: "Employee",
    type: "select",
    apiResKey: "employees",
    api: getEmployees,
  },
];

export const INSURANCE_REQUIRED_FIELDS = [
  { key: "insurance_type", label: "insurance_type" },
  { key: "insurance_number", label: "insurance_number" },
  {
    key: "insurance_active",
    label: "insurance_active",
    type: "fixed-select",
    options: [
      { label: "Yes", value: true },
      { label: "No", value: false },
    ],
  },
  { key: "insurance_end_date", label: "insurance_end_date", type: "date" },
];

export const FIELDS = [...INSURANCE_FIELDS, ...INSURANCE_REQUIRED_FIELDS];
